import http from './http';

const WORK_PERIOD_PATH = '/work_period';

const workPeriodSvcClient = {
  create(data) {
    return http
      .post(`${WORK_PERIOD_PATH}`, data)
      .then(({ data }) => data)
      .catch(e => {
        if (e?.response?.data?.error?.message) {
          throw new Error(e.response.data.error.message);
        }
      });
  },
  get(businessId) {
    return http
      .get(`${WORK_PERIOD_PATH}/installation/${businessId}`)
      .then(({ data }) => data)
      .catch(e => {
        if (e?.response?.data?.error?.message) {
          throw new Error(e.response.data.error.message);
        }
      });
  },
};

export default workPeriodSvcClient;
